import { createStore } from 'reflux';
import SaneStore from '../utils/sane-store-mixin';
import BudgetActions from '../actions/budget';

const CleanData = data => {
	let filteredata = data.filter(item => {
		return item.location !== 0;
	});
	return filteredata;
}

const BudgetStore = createStore({
  initialData: [],
  mixins: [SaneStore],
  listenables: BudgetActions,
  init() {
    this.listenTo(BudgetActions.loadCompleted, 'loadData');
  },
  loadData(data) {
    this.setData(CleanData(data));
  },
});


export default BudgetStore;



/** WEBPACK FOOTER **
 ** ./app/scripts/stores/budget.es6
 **/